// "Corretor" não é tabela separada — CRUD de usuário/corretor é CRUD de
// sub-usuário de `catalog.users` (nivel 2/3), ver models/usuario.js do
// painel-node. Uma tela só (nível 1 e nível 2 usam a mesma, API já
// unifica isso — o original tinha 2 telas sobrepostas pra isso, decisão
// de não replicar essa duplicação, ver CLAUDE.md deste projeto).
export const CAMPOS_USUARIO = [
  { nome: 'name', rotulo: 'Nome', tipo: 'text', obrigatorio: true },
  { nome: 'email', rotulo: 'E-mail', tipo: 'email', obrigatorio: true, soNaCriacao: true },
  { nome: 'celular', rotulo: 'Celular', tipo: 'text' },
  { nome: 'telegram', rotulo: 'Telegram', tipo: 'text' },
  { nome: 'email_trello', rotulo: 'E-mail Trello', tipo: 'email' },
  { nome: 'creci', rotulo: 'CRECI', tipo: 'text' },
  { nome: 'estado', rotulo: 'Estado (UF)', tipo: 'text' },
  { nome: 'possuiwhats', rotulo: 'Possui WhatsApp', tipo: 'checkbox' },
  { nome: 'rodizio', rotulo: 'Participa do rodízio de corretores', tipo: 'checkbox' },
  { nome: 'bloqueio', rotulo: 'Bloqueado', tipo: 'checkbox' },
  { nome: 'modelo_msg_email', rotulo: 'Modelo de mensagem — e-mail', tipo: 'textarea' },
  { nome: 'modelo_msg_whats', rotulo: 'Modelo de mensagem — WhatsApp', tipo: 'textarea' },
  { nome: 'modelo_msg_sms', rotulo: 'Modelo de mensagem — SMS', tipo: 'textarea' },
];

export function valoresIniciais(usuario) {
  // `empresaId` (seletor manual, achado em auditoria 2026-09-19: superadmin
  // criando usuário SEM uma empresa pré-selecionada na URL precisa escolher
  // no próprio form, ver FormUsuario.js) não é coluna de `catalog.users` —
  // não faz parte do loop de CAMPOS_USUARIO.
  const base = { nivel: '2', empresaId: '' };
  for (const campo of CAMPOS_USUARIO) {
    if (campo.tipo === 'checkbox') {
      base[campo.nome] = usuario ? usuario[campo.nome] === 'true' : false;
    } else {
      base[campo.nome] = usuario?.[campo.nome] ?? '';
    }
  }
  if (usuario) base.nivel = String(usuario.nivel);
  return base;
}

// Na edição, `email`/`nivel` não são enviados (backend não aceita mudar
// depois de criado — email nem está em CAMPOS de updateUsuario, nivel
// também não).
export function paraApi(valores, ehNovo) {
  const saida = {};
  for (const campo of CAMPOS_USUARIO) {
    if (campo.soNaCriacao && !ehNovo) continue;
    const valor = valores[campo.nome];
    saida[campo.nome] = campo.tipo === 'checkbox' ? (valor ? 'true' : 'false') : valor === '' ? null : valor;
  }
  if (ehNovo) {
    saida.nivel = Number(valores.nivel);
    // Superadmin (nivel 1) não tem empresa — só manda `empresa_id` quando
    // faz sentido e foi escolhido (ver FormUsuario.js).
    if (saida.nivel !== 1 && valores.empresaId) saida.empresa_id = valores.empresaId;
  }
  return saida;
}
